import React from 'react';
import { BaseInput } from '../../../../designSystem/components/BaseInput';
import { Dropdown } from '../../../../designSystem/components/Dropdown';
import { DateInput } from '../../../../designSystem/components/DateInput';
import { CheckButton } from '../../../../designSystem/components/CheckButton';
import {Typography} from "../../../../designSystem/components/Typography";
import { BmiInput } from '../BmiInput';
import { REGION_OPTIONS } from '../../../../utils/constants';

const REGIONS = REGION_OPTIONS.map((r) => r.value).filter((r) => r !== '不限');

export type ProfileEditFormData = {
  name: string;
  gender: string;
  yearRoc: string;
  month: string;
  day: string;
  region: string;
  isIndigenous: boolean;
  weightKg: string;
  heightCm: string;
};

type ProfileEditFormProps = {
  formData: ProfileEditFormData;
  onChange: (patch: Partial<ProfileEditFormData>) => void;
};

export const ProfileEditForm = ({ formData, onChange }: ProfileEditFormProps) => {
  const {
    name,
    gender,
    yearRoc,
    month,
    day,
    region,
    isIndigenous,
    weightKg,
    heightCm,
  } = formData;

  return (
    <div className="flex flex-col p-4 gap-4">
      <div className="grid grid-cols-2 gap-4">
        <div className="flex flex-col gap-2">
          <Typography variant="bodyBold">
            *姓名
          </Typography>
          <BaseInput
            type="string"
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              onChange({name: e.target.value})
            }
            value={name}
            placeholder="姓名"
          />
        </div>

        <div className="flex flex-col gap-2">
          <Typography variant="bodyBold">
            *性別
          </Typography>
          <Dropdown
            className=""
            hasDiv={false}
            options={['男', '女']}
            dataSelected={gender}
            disabled={false}
            onChange={(e) =>
              onChange({gender: e.target.value})
            }
            text="性別"
          />
        </div>
      </div>

      <div className="flex flex-col gap-2">
        <Typography variant="bodyBold">
          *出生日期
        </Typography>
        <DateInput
          yearRoc={yearRoc}
          month={month}
          day={day}
          onChangeYearRoc={(v: string) => onChange({yearRoc: v})}
          onChangeMonth={(v: string) => onChange({month: v})}
          onChangeDay={(v: string) => onChange({day: v})}
        />
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div className="flex flex-col gap-2">
          <Typography variant="bodyBold">
            *鄉鎮縣市
          </Typography>
          <Dropdown
            className="flex flex-1"
            hasDiv={false}
            options={REGIONS}
            dataSelected={region}
            disabled={false}
            onChange={(e) =>
              onChange({region: e.target.value})
            }
            text=""
          />
        </div>

        <div className="flex flex-col gap-2">
          <Typography variant="bodyBold">
            是否為原住民
          </Typography>
          <CheckButton
            selected={isIndigenous}
            label="我是原住民"
            onClick={() => onChange({isIndigenous: !isIndigenous})}
          />
        </div>
      </div>

      <div className="flex flex-col gap-2">
        <Typography variant="bodyBold">
          *身高體重
        </Typography>
        <BmiInput
          weightKg={weightKg}
          heightCm={heightCm}
          onChangeHeightCm={(v: string) => onChange({heightCm: v})}
          onChangeWeightKg={(v: string) => onChange({weightKg: v})}
        />
      </div>
    </div>
  );
};